import { render, staticRenderFns } from "./Applied.vue?vue&type=template&id=961978f8&scoped=true&"
import script from "./Applied.vue?vue&type=script&lang=js&"
export * from "./Applied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961978f8",
  null
  
)

export default component.exports